import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/warning-circle.svg'
import _imports_1 from '@/app/ui/assets/svg/exclamation-circle-solid.svg'
import _imports_2 from '@/app/ui/assets/svg/success-status.svg'
import _imports_3 from '@/app/ui/assets/svg/exclamation-triangle.svg'


const _hoisted_1 = {
  key: 0,
  class: "flex flex-row justify-between"
}
const _hoisted_2 = { class: "flex flex-row pl-4" }
const _hoisted_3 = {
  key: 0,
  class: "bg-gray-lp-1500 p-4 mt-4 mr-4 rounded-md flex flex-row"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "max-w-none w-6",
  alt: "total-dex"
}, null, -1)
const _hoisted_5 = { class: "text-14px font-normal pt-1 pl-2" }
const _hoisted_6 = {
  key: 1,
  class: "bg-gray-lp-1500 p-4 mt-4 mr-4 rounded-md flex flex-row"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "max-w-none w-6",
  alt: "total-dex"
}, null, -1)
const _hoisted_8 = { class: "text-14px font-normal pt-1 pl-2" }
const _hoisted_9 = { class: "p-4 grid grid-cols-3 gap-4" }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_11 = { class: "p-4 font-semibold text-14px" }
const _hoisted_12 = { class: "p-4 font-semibold text-16px bg-gray-lp-1000" }
const _hoisted_13 = { class: "p-4 " }
const _hoisted_14 = { class: "p-4 font-semibold text-16px bg-gray-lp-1000" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "flex flex-row justify-between" }
const _hoisted_17 = { class: "flex flex-row p-field-checkbox" }
const _hoisted_18 = { class: "p-4 text-gray-lp-600" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  class: "flex flex-row"
}
const _hoisted_21 = {
  key: 0,
  src: _imports_2,
  class: "max-w-none w-4",
  alt: "success"
}
const _hoisted_22 = {
  key: 1,
  src: _imports_3,
  class: "max-w-none w-4",
  alt: "success"
}
const _hoisted_23 = {
  key: 0,
  class: "p-4 text-gray-lp-600 italic text-12px"
}
const _hoisted_24 = { class: "flex flex-row justify-between" }
const _hoisted_25 = { class: "flex flex-row p-field-checkbox" }
const _hoisted_26 = { class: "p-4 text-gray-lp-600" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 1,
  class: "flex flex-row"
}
const _hoisted_29 = {
  key: 0,
  src: _imports_2,
  class: "max-w-none w-4",
  alt: "success"
}
const _hoisted_30 = {
  key: 1,
  src: _imports_3,
  class: "max-w-none w-4",
  alt: "success"
}
const _hoisted_31 = {
  key: 0,
  class: "p-4 text-gray-lp-600 italic text-12px"
}
const _hoisted_32 = { class: "px-4 pb-4 text-gray-lp-300" }
const _hoisted_33 = { class: "flex flex-row justify-between" }
const _hoisted_34 = { class: "flex flex-row p-field-checkbox" }
const _hoisted_35 = { class: "p-4 text-gray-lp-600" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  key: 1,
  class: "flex flex-row"
}
const _hoisted_38 = {
  key: 0,
  src: _imports_2,
  class: "max-w-none w-4",
  alt: "success"
}
const _hoisted_39 = {
  key: 1,
  src: _imports_3,
  class: "max-w-none w-4",
  alt: "success"
}
const _hoisted_40 = {
  key: 0,
  class: "p-4 text-gray-lp-600 italic text-12px"
}
const _hoisted_41 = { class: "px-4" }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "p-4 text-gray-lp-600" }
const _hoisted_44 = {
  key: 0,
  class: "px-4 pb-4"
}
const _hoisted_45 = {
  key: 1,
  class: "px-4 pb-4"
}
const _hoisted_46 = { class: "flex flex-row justify-between" }
const _hoisted_47 = { class: "flex flex-row p-field-checkbox" }
const _hoisted_48 = { class: "p-4 text-gray-lp-600" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = {
  key: 1,
  class: "flex flex-row"
}
const _hoisted_51 = {
  key: 0,
  src: _imports_2,
  class: "max-w-none w-4",
  alt: "success"
}
const _hoisted_52 = {
  key: 1,
  src: _imports_3,
  class: "max-w-none w-4",
  alt: "success"
}
const _hoisted_53 = {
  key: 0,
  class: "p-4 text-gray-lp-600 italic text-12px"
}
const _hoisted_54 = {
  key: 0,
  class: "px-4 pb-4"
}
const _hoisted_55 = {
  key: 1,
  class: "px-4 pb-4"
}
const _hoisted_56 = {
  key: 0,
  class: "grid grid-cols-2 gap-2 pb-2"
}
const _hoisted_57 = { class: "px-2 flex flex-col" }
const _hoisted_58 = { class: "text-gray-lp-600 font-normal" }
const _hoisted_59 = { class: "flex-flex-row" }
const _hoisted_60 = { class: "pl-1" }
const _hoisted_61 = { class: "px-2 flex flex-col" }
const _hoisted_62 = { class: "text-gray-lp-600 font-normal" }
const _hoisted_63 = { class: "flex-flex-row" }
const _hoisted_64 = { class: "pl-1" }
const _hoisted_65 = { class: "px-2 flex flex-col" }
const _hoisted_66 = { class: "text-gray-lp-600 font-normal" }
const _hoisted_67 = { class: "flex-flex-row" }
const _hoisted_68 = { class: "pl-1" }
const _hoisted_69 = { class: "px-2 flex flex-col" }
const _hoisted_70 = { class: "text-gray-lp-600 font-normal" }
const _hoisted_71 = { class: "flex-flex-row" }
const _hoisted_72 = { class: "pl-1" }
const _hoisted_73 = { class: "flex flex-row p-4" }
const _hoisted_74 = { class: "p4 flex flex-col pt-3" }
const _hoisted_75 = { class: "font-semibold text-16px text-gray-lp-600" }
const _hoisted_76 = { class: "flex flex-row items-center gap-2" }
const _hoisted_77 = { class: "text-16px font-semibold" }
const _hoisted_78 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_79 = { class: "grid grid-cols-2 gap-4 p-4" }
const _hoisted_80 = { class: "text-16px text-gray-lp-300" }
const _hoisted_81 = { class: "text-16px text-gray-lp-300" }
const _hoisted_82 = { class: "text-16px text-gray-lp-300" }
const _hoisted_83 = { class: "text-16px text-gray-lp-300" }
const _hoisted_84 = { class: "text-16px text-gray-lp-300" }
const _hoisted_85 = { class: "text-16px text-gray-lp-300" }
const _hoisted_86 = { class: "text-16px text-gray-lp-300" }
const _hoisted_87 = { class: "text-16px text-gray-lp-300" }
const _hoisted_88 = {
  key: 2,
  class: "w-full grid grid-cols-2 gap-1"
}
const _hoisted_89 = {
  key: 3,
  class: "w-full grid grid-cols-2 gap-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chips = _resolveComponent("Chips")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Card = _resolveComponent("Card")!
  const _component_UploadImageFileName = _resolveComponent("UploadImageFileName")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_AIAssessmentBanner = _resolveComponent("AIAssessmentBanner")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_PreviewImage = _resolveComponent("PreviewImage")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "my-4" }, {
      default: _withCtx(() => [
        (_ctx.isConsole)
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode("div", _hoisted_2, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('dexAssessment.columnStatusDexAsesmen'),
                  class: "pt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Chips, {
                      class: "my-2",
                      color: "red-lp-1300",
                      textColor: "orange-lp-200",
                      weight: "semibold",
                      label: 
              _ctx.data.daStatus === 'valid'
                ? _ctx.$t('dexAssessment.statusValid')
                : _ctx.$t('dexAssessment.statusInvalid')
            ,
                      rounded: ""
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('dexAssessment.columnStatusSanggah'),
                  class: "pt-4 pl-4"
                }, {
                  default: _withCtx(() => [
                    (_ctx.data.daStatusDisputePartner === '')
                      ? (_openBlock(), _createBlock(_component_Chips, {
                          key: 0,
                          class: "my-2",
                          weight: "semibold",
                          color: "gray-lp-200",
                          textColor: "gray-lp-300",
                          label: "-",
                          rounded: ""
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.data.daStatusDisputePartner === 'accepted')
                      ? (_openBlock(), _createBlock(_component_Chips, {
                          key: 1,
                          class: "my-2",
                          weight: "semibold",
                          color: "gray-lp-200",
                          textColor: "gray-lp-300",
                          label: "-",
                          rounded: ""
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.data.daStatusDisputePartner === 'rejected')
                      ? (_openBlock(), _createBlock(_component_Chips, {
                          key: 2,
                          class: "my-2",
                          weight: "semibold",
                          color: "red-lp-1300",
                          textColor: "orange-lp-200",
                          label: _ctx.$t('dexAssessment.statusDisputeRejected'),
                          rounded: ""
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true),
                    (_ctx.data.daStatusDisputePartner === 'requested')
                      ? (_openBlock(), _createBlock(_component_Chips, {
                          key: 3,
                          class: "my-2",
                          weight: "semibold",
                          color: "yellow-lp-200",
                          textColor: "yellow-lp-100",
                          label: _ctx.$t('dexAssessment.statusDisputeRequested'),
                          rounded: ""
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true),
                    (_ctx.data.daStatusDisputePartner === 'approved')
                      ? (_openBlock(), _createBlock(_component_Chips, {
                          key: 4,
                          class: "my-2",
                          weight: "semibold",
                          color: "green-lp-500",
                          textColor: "green-lp-200",
                          label: _ctx.$t('dexAssessment.statusDisputeApproved'),
                          rounded: ""
                        }, null, 8, ["label"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              (!_ctx.isShowTimeOverDispute && _ctx.data.daStatusDisputePartner === '')
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    _hoisted_4,
                    _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("dexAssessment.disputeBefore", { timeLeft: _ctx.timeLeft })), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isShowTimeOverDispute && _ctx.data.daStatusDisputePartner === '')
                ? (_openBlock(), _createBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("dexAssessment.timeOverDispute")), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_9, [
          (_ctx.isDisputeConsole)
            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                _createVNode(_component_Card, null, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("dexAssessment.fotoSanggahanKonsol")), 1),
                    (_ctx.data.daProofPhotoDisputePartner[0])
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          src: _ctx.data.daProofPhotoDisputePartner[0],
                          class: "max-w-none w-full cursor-pointer",
                          style: {"height":"500px"},
                          alt: "total-dex",
                          onClick: _cache[1] || (_cache[1] = () => _ctx.actionModalPreview(true, 'console'))
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("dexAssessment.catatanDariKonsol")), 1),
                    _createVNode("div", _hoisted_13, _toDisplayString(_ctx.data.daRemarksPartner), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Card, { class: "mt-2 w-1/4" }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("dexAssessment.fotoDex")), 1),
                    (_ctx.data.daDeliveryProofPhoto[0])
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          src: _ctx.data.daDeliveryProofPhoto[0],
                          class: "max-w-none w-full cursor-pointer",
                          style: {"height":"150px"},
                          alt: "total-dex",
                          onClick: _cache[2] || (_cache[2] = () => _ctx.actionModalPreview(true, 'dex'))
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_15, [
                _createVNode("img", {
                  src: _ctx.data.daDeliveryProofPhoto[0],
                  class: "max-w-none w-11/12 cursor-pointer",
                  style: {"height":"500px"},
                  alt: "total-dex",
                  onClick: _cache[3] || (_cache[3] = () => _ctx.actionModalPreview(true, 'dex'))
                }, null, 8, ["src"]),
                (!_ctx.isShowTimeOverDispute && _ctx.isConsole)
                  ? (_openBlock(), _createBlock(_component_DataWrapper, {
                      key: 0,
                      label: _ctx.$t('dexAssessment.lampirkanFotoSanggahan'),
                      class: "pt-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UploadImageFileName, {
                          title: _ctx.$t('dexAssessment.lampirkanFoto'),
                          modelValue: _ctx.data.daProofPhotoDisputePartner,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.data.daProofPhotoDisputePartner = $event)),
                          disabled: !_ctx.isShowDispute
                        }, null, 8, ["title", "modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true),
                (!_ctx.isShowTimeOverDispute && _ctx.isConsole)
                  ? (_openBlock(), _createBlock(_component_DataWrapper, {
                      key: 1,
                      label: _ctx.$t('dexAssessment.komentarSanggahan'),
                      class: "pt-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lp_input, {
                          placeholder: _ctx.$t('dexAssessment.placeholderSanggahan'),
                          type: "textarea",
                          textAreaRows: "3",
                          maxLength: 255,
                          showMaxLength: true,
                          modelValue: _ctx.data.daRemarksPartner,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.data.daRemarksPartner = $event)),
                          disabled: !_ctx.isShowDispute
                        }, null, 8, ["placeholder", "modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true)
              ])),
          _createVNode("div", null, [
            _createVNode(_component_Card, null, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, [
                    _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("dexAssessment.proofPhoto")), 1),
                    (_ctx.editable)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "custom-checkbox cursor-pointer",
                          onClick: _cache[6] || (_cache[6] = 
                  () => _ctx.toggleCheckbox(_ctx.data.daPhotoProofAssessment, 'photo')
                )
                        }, [
                          _createVNode("div", {
                            class: {
                    'checkbox-icon': true,
                    checked: _ctx.data.daPhotoProofAssessment
                  }
                          }, [
                            (_ctx.data.daPhotoProofAssessment)
                              ? (_openBlock(), _createBlock("span", _hoisted_19, "x"))
                              : _createCommentVNode("", true)
                          ], 2)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_20, [
                          (!_ctx.data.daPhotoProofAssessment)
                            ? (_openBlock(), _createBlock("img", _hoisted_21))
                            : _createCommentVNode("", true),
                          (_ctx.data.daPhotoProofAssessment)
                            ? (_openBlock(), _createBlock("img", _hoisted_22))
                            : _createCommentVNode("", true),
                          _createVNode("span", {
                            class: 
                    `text-14px pt-4 pl-2 ${
                      !_ctx.data.daPhotoProofAssessment
                        ? 'text-green-lp-400'
                        : 'text-red-lp-1200'
                    }`
                  
                          }, _toDisplayString(!_ctx.data.daPhotoProofAssessment
                      ? _ctx.$t("dexAssessment.statusValid")
                      : _ctx.$t("dexAssessment.statusInvalid")), 3)
                        ]))
                  ]),
                  (
                _ctx.data.daPhotoProofAssessment &&
                  _ctx.data.daPhotoProofAssessmentFromSystem
              )
                    ? (_openBlock(), _createBlock("div", _hoisted_23, _toDisplayString(_ctx.$t("dexAssessment.automaticBySystem")), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Card, { class: "mt-2" }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_24, [
                  _createVNode("div", _hoisted_25, [
                    _createVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("dexAssessment.reasonDex")), 1),
                    (_ctx.editable)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "custom-checkbox cursor-pointer",
                          onClick: _cache[7] || (_cache[7] = 
                  () => _ctx.toggleCheckbox(_ctx.data.daReasonDexAssessment, 'reason')
                )
                        }, [
                          _createVNode("div", {
                            class: {
                    'checkbox-icon': true,
                    checked: _ctx.data.daReasonDexAssessment
                  }
                          }, [
                            (_ctx.data.daReasonDexAssessment)
                              ? (_openBlock(), _createBlock("span", _hoisted_27, "x"))
                              : _createCommentVNode("", true)
                          ], 2)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_28, [
                          (!_ctx.data.daReasonDexAssessment)
                            ? (_openBlock(), _createBlock("img", _hoisted_29))
                            : _createCommentVNode("", true),
                          (_ctx.data.daReasonDexAssessment)
                            ? (_openBlock(), _createBlock("img", _hoisted_30))
                            : _createCommentVNode("", true),
                          _createVNode("span", {
                            class: 
                    `text-14px pt-4 pl-2 ${
                      !_ctx.data.daReasonDexAssessment
                        ? 'text-green-lp-400'
                        : 'text-red-lp-1200'
                    }`
                  
                          }, _toDisplayString(!_ctx.data.daReasonDexAssessment
                      ? _ctx.$t("dexAssessment.statusValid")
                      : _ctx.$t("dexAssessment.statusInvalid")), 3)
                        ]))
                  ]),
                  (
                _ctx.data.daReasonDexAssessment &&
                  _ctx.data.daReasonDexAssessmentFromSystem
              )
                    ? (_openBlock(), _createBlock("div", _hoisted_31, _toDisplayString(_ctx.$t("dexAssessment.automaticFromSystem")), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_32, _toDisplayString(_ctx.data.daDeliveryReasonTitle) + " - " + _toDisplayString(_ctx.data.daDeliveryReasonCode), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Card, { class: "mt-2" }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_33, [
                  _createVNode("div", _hoisted_34, [
                    _createVNode("div", _hoisted_35, _toDisplayString(_ctx.$t("dexAssessment.locationDex")), 1),
                    (_ctx.editable)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "custom-checkbox cursor-pointer",
                          onClick: _cache[8] || (_cache[8] = 
                  () => _ctx.toggleCheckbox(_ctx.data.daLocationDexAssessment, 'location')
                )
                        }, [
                          _createVNode("div", {
                            class: {
                    'checkbox-icon': true,
                    checked: _ctx.data.daLocationDexAssessment
                  }
                          }, [
                            (_ctx.data.daLocationDexAssessment)
                              ? (_openBlock(), _createBlock("span", _hoisted_36, "x"))
                              : _createCommentVNode("", true)
                          ], 2)
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_37, [
                          (!_ctx.data.daLocationDexAssessment)
                            ? (_openBlock(), _createBlock("img", _hoisted_38))
                            : _createCommentVNode("", true),
                          (_ctx.data.daLocationDexAssessment)
                            ? (_openBlock(), _createBlock("img", _hoisted_39))
                            : _createCommentVNode("", true),
                          _createVNode("span", {
                            class: 
                    `text-14px pt-4 pl-2 ${
                      !_ctx.data.daLocationDexAssessment
                        ? 'text-green-lp-400'
                        : 'text-red-lp-1200'
                    }`
                  
                          }, _toDisplayString(!_ctx.data.daLocationDexAssessment
                      ? _ctx.$t("dexAssessment.statusValid")
                      : _ctx.$t("dexAssessment.statusInvalid")), 3)
                        ]))
                  ]),
                  (
                _ctx.data.daLocationDexAssessment &&
                  _ctx.data.daLocationDexAssessmentFromSystem
              )
                    ? (_openBlock(), _createBlock("div", _hoisted_40, _toDisplayString(_ctx.$t("dexAssessment.automaticFromSystem")), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_41, [
                  (_ctx.data.daDeliveryAddressDex)
                    ? (_openBlock(), _createBlock("span", {
                        key: 0,
                        class: "underline text-blue-600 cursor-pointer",
                        onClick: _cache[9] || (_cache[9] = () => _ctx.openLink(_ctx.data.daDeliveryGeolocationDex))
                      }, _toDisplayString(_ctx.data.daDeliveryAddressDex), 1))
                    : (_openBlock(), _createBlock("span", _hoisted_42, "-"))
                ]),
                _createVNode("div", _hoisted_43, _toDisplayString(_ctx.$t("dexAssessment.recipientAddress")), 1),
                (_ctx.data.daSttRecipientAddress)
                  ? (_openBlock(), _createBlock("div", _hoisted_44, _toDisplayString(_ctx.data.daSttRecipientAddress) + ", " + _toDisplayString(_ctx.data.daDestinationDistrictName), 1))
                  : (_openBlock(), _createBlock("div", _hoisted_45, "-"))
              ]),
              _: 1
            }),
            _createVNode(_component_Card, { class: "mt-2" }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_46, [
                  _createVNode("div", _hoisted_47, [
                    _createVNode("div", _hoisted_48, _toDisplayString(_ctx.$t("dexAssessment.sourceDex")), 1),
                    (_ctx.editable)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: 
                  `custom-checkbox ${
                    _ctx.uneditableSourceDex
                      ? 'cursor-not-allowed'
                      : 'cursor-pointer'
                  }`
                ,
                          onClick: _cache[10] || (_cache[10] = 
                  () => _ctx.toggleCheckbox(_ctx.data.daSourceDexAssessment, 'source')
                )
                        }, [
                          _createVNode("div", {
                            class: {
                    'checkbox-icon': true,
                    checked: _ctx.data.daSourceDexAssessment
                  }
                          }, [
                            (_ctx.data.daSourceDexAssessment)
                              ? (_openBlock(), _createBlock("span", _hoisted_49, "x"))
                              : _createCommentVNode("", true)
                          ], 2)
                        ], 2))
                      : (_openBlock(), _createBlock("div", _hoisted_50, [
                          (!_ctx.data.daSourceDexAssessment)
                            ? (_openBlock(), _createBlock("img", _hoisted_51))
                            : _createCommentVNode("", true),
                          (_ctx.data.daSourceDexAssessment)
                            ? (_openBlock(), _createBlock("img", _hoisted_52))
                            : _createCommentVNode("", true),
                          _createVNode("span", {
                            class: 
                    `text-14px pt-4 pl-2 ${
                      !_ctx.data.daSourceDexAssessment
                        ? 'text-green-lp-400'
                        : 'text-red-lp-1200'
                    }`
                  
                          }, _toDisplayString(!_ctx.data.daSourceDexAssessment
                      ? _ctx.$t("dexAssessment.statusValid")
                      : _ctx.$t("dexAssessment.statusInvalid")), 3)
                        ]))
                  ]),
                  (
                _ctx.data.daSourceDexAssessment &&
                  _ctx.data.daSourceDexAssessmenFromSystemt
              )
                    ? (_openBlock(), _createBlock("div", _hoisted_53, _toDisplayString(_ctx.$t("dexAssessment.automaticFromSystem")), 1))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.data.daSourceDex)
                  ? (_openBlock(), _createBlock("div", _hoisted_54, _toDisplayString(_ctx.data.daSourceDex), 1))
                  : (_openBlock(), _createBlock("div", _hoisted_55, "-"))
              ]),
              _: 1
            }),
            (_ctx.isAgentDexL1)
              ? (_openBlock(), _createBlock(_component_LpButton, {
                  key: 0,
                  textColor: "white",
                  title: _ctx.$t('dexAssessment.finish'),
                  fontWeight: "semibold",
                  onClick: _ctx.doneDEX,
                  class: "mt-4",
                  isWidthFull: ""
                }, null, 8, ["title", "onClick"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", null, [
            _createVNode(_component_AIAssessmentBanner, { shouldShow: _ctx.shouldShowAIBanner }, null, 8, ["shouldShow"]),
            (!_ctx.isAgentDexL1)
              ? (_openBlock(), _createBlock("div", _hoisted_56, [
                  _createVNode(_component_Card, { class: "col-span-1 py-4" }, {
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_57, [
                        _createVNode("span", _hoisted_58, _toDisplayString(_ctx.$t("dexAssessment.recipient")), 1),
                        _createVNode("span", null, _toDisplayString(_ctx.data.daRecipientName), 1),
                        _createVNode("div", _hoisted_59, [
                          _createVNode(_component_Icons, {
                            name: "whatsapp",
                            class: "w-4 text-green-lp-100 cursor-pointer",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.goToWhatsapp(_ctx.data.daRecipientPhone)))
                          }),
                          _createVNode("span", _hoisted_60, _toDisplayString(_ctx.data.daRecipientPhone), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Card, { class: "col-span-1 py-4" }, {
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_61, [
                        _createVNode("span", _hoisted_62, _toDisplayString(_ctx.$t("dexAssessment.sender")), 1),
                        _createVNode("span", null, _toDisplayString(_ctx.data.daSenderName), 1),
                        _createVNode("div", _hoisted_63, [
                          _createVNode(_component_Icons, {
                            name: "whatsapp",
                            class: "w-4 text-green-lp-100 cursor-pointer",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.goToWhatsapp(_ctx.data.daSenderPhone)))
                          }),
                          _createVNode("span", _hoisted_64, _toDisplayString(_ctx.data.daSenderPhone), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Card, { class: "col-span-1 py-4" }, {
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_65, [
                        _createVNode("span", _hoisted_66, _toDisplayString(_ctx.$t("dexAssessment.courier")), 1),
                        _createVNode("span", null, _toDisplayString(_ctx.data.daDeliveryCourierName), 1),
                        _createVNode("div", _hoisted_67, [
                          _createVNode(_component_Icons, {
                            name: "whatsapp",
                            class: "w-4 text-green-lp-100 cursor-pointer",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.goToWhatsapp(_ctx.data.daDeliveryCourierPhone)))
                          }),
                          _createVNode("span", _hoisted_68, _toDisplayString(_ctx.data.daDeliveryCourierPhone), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Card, { class: "col-span-1 py-4" }, {
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_69, [
                        _createVNode("span", _hoisted_70, _toDisplayString(_ctx.data.daDeliveryCaptainCourierName
                    ? _ctx.$t("dexAssessment.courierCaptain")
                    : _ctx.$t("dexAssessment.consolidator")), 1),
                        _createVNode("span", null, _toDisplayString(_ctx.data.daDeliveryCaptainCourierName ||
                    _ctx.data.daAssignedPartnerName), 1),
                        _createVNode("div", _hoisted_71, [
                          _createVNode(_component_Icons, {
                            name: "whatsapp",
                            class: "w-4 text-green-lp-100 cursor-pointer",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (
                    _ctx.goToWhatsapp(
                      _ctx.data.daDeliveryCaptainCourierPhone ||
                        _ctx.data.daAssignedPartnerPhone
                    )
                  ))
                          }),
                          _createVNode("span", _hoisted_72, _toDisplayString(_ctx.data.daDeliveryCaptainCourierPhone ||
                      _ctx.data.daAssignedPartnerPhone), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_Card, null, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_73, [
                  _createVNode("div", _hoisted_74, [
                    _createVNode("div", _hoisted_75, _toDisplayString(_ctx.$t("dexAssessment.ticketId")), 1),
                    _createVNode("div", _hoisted_76, [
                      _createVNode("div", _hoisted_77, _toDisplayString(_ctx.data.daTicketNo), 1),
                      _createVNode("div", {
                        class: "text-16px font-semibold text-red-lp-100 pl-4 cursor-pointer",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.toDetail(_ctx.data.daId)))
                      }, _toDisplayString(_ctx.$t("dexAssessment.viewDetail")), 1)
                    ])
                  ])
                ]),
                _hoisted_78,
                _createVNode("div", _hoisted_79, [
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('dexAssessment.sttNumber'),
                    class: "col-span-1 pt-4 text-gray-lp-600 font-normal"
                  }, {
                    default: _withCtx(() => [
                      _createVNode("span", _hoisted_80, _toDisplayString(_ctx.data.daSttNo), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('dexAssessment.route'),
                    class: "col-span-1 pt-4 text-gray-lp-600 font-normal"
                  }, {
                    default: _withCtx(() => [
                      _createVNode("span", _hoisted_81, _toDisplayString(_ctx.data.daOriginId) + " - " + _toDisplayString(_ctx.data.daDestinationId), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  (!_ctx.isConsole)
                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                        key: 0,
                        label: _ctx.$t('dexAssessment.addressType'),
                        class: "col-span-1 pt-4 text-gray-lp-600 font-normal"
                      }, {
                        default: _withCtx(() => [
                          _createVNode("span", _hoisted_82, _toDisplayString(_ctx.data.daSttRecipientAddressType), 1)
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (!_ctx.isConsole)
                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                        key: 1,
                        label: _ctx.$t('dexAssessment.dexAttempt'),
                        class: "col-span-1 pt-4 text-gray-lp-600 font-normal"
                      }, {
                        default: _withCtx(() => [
                          _createVNode("span", _hoisted_83, _toDisplayString(_ctx.data.daDeliveryDexAttempt), 1)
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (!_ctx.isConsole)
                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                        key: 2,
                        label: _ctx.$t('dexAssessment.productType'),
                        class: "col-span-1 pt-4 text-gray-lp-600 font-normal"
                      }, {
                        default: _withCtx(() => [
                          _createVNode("span", _hoisted_84, _toDisplayString(_ctx.data.daProductType), 1)
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (_ctx.isConsole)
                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                        key: 3,
                        label: _ctx.$t('dexAssessment.sla'),
                        class: "col-span-1 pt-4 text-gray-lp-600 font-normal"
                      }, {
                        default: _withCtx(() => [
                          _createVNode("span", _hoisted_85, _toDisplayString(_ctx.data.daSttSla), 1)
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (!_ctx.isAgentDexL1)
                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                        key: 4,
                        label: _ctx.$t('dexAssessment.customerDispute'),
                        class: "col-span-1 pt-4 text-gray-lp-600 font-normal"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Chips, {
                            class: "my-2",
                            color: "red-lp-1300",
                            textColor: "orange-lp-200",
                            label: 
                  _ctx.data.daDisputeCustomer
                    ? _ctx.$t('dexAssessment.yes')
                    : _ctx.$t('dexAssessment.no')
                ,
                            rounded: ""
                          }, null, 8, ["label"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (!_ctx.isConsole)
                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                        key: 5,
                        label: _ctx.$t('dexAssessment.sla'),
                        class: "col-span-2 pt-4 text-gray-lp-600 font-normal"
                      }, {
                        default: _withCtx(() => [
                          _createVNode("span", _hoisted_86, _toDisplayString(_ctx.data.daSttSla), 1)
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('dexAssessment.dexTime'),
                    class: "col-span-2 pt-4 text-gray-lp-600 font-normal"
                  }, {
                    default: _withCtx(() => [
                      _createVNode("span", _hoisted_87, _toDisplayString(_ctx.deliveryDate(_ctx.data.daDeliveryDexDateLocal)), 1)
                    ]),
                    _: 1
                  }, 8, ["label"])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        (
        !_ctx.isDisputeConsole &&
          !_ctx.isAgentDexL1 &&
          !_ctx.isConsole &&
          !_ctx.data.daFinishedL2DisputeDate &&
          !_ctx.data.daFinishedL2Date
      )
          ? (_openBlock(), _createBlock(_component_LpButton, {
              key: 1,
              textColor: "white",
              title: _ctx.$t('dexAssessment.finish'),
              fontWeight: "semibold",
              onClick: _ctx.doneDEX,
              class: "my-4 mx-2",
              isWidthFull: ""
            }, null, 8, ["title", "onClick"]))
          : _createCommentVNode("", true),
        (
        _ctx.isDisputeConsole &&
          !_ctx.data.daFinishedL2DisputeDate &&
          _ctx.isShowDisputeL2Assigne
      )
          ? (_openBlock(), _createBlock("div", _hoisted_88, [
              _createVNode(_component_LpButton, {
                disabled: _ctx.data.daRemarksL2Dispute.length < 3,
                textColor: "white",
                color: 
          _ctx.data.daRemarksL2Dispute.length < 3 ? 'gray-lp-600' : 'red-lp-100'
        ,
                title: _ctx.$t('dexAssessment.disagree'),
                fontWeight: "semibold",
                onClick: _cache[16] || (_cache[16] = () => (_ctx.data.daRemarksL2Dispute.length < 3 ? {} : _ctx.rejectedDex())),
                class: "my-4 mx-2",
                isWidthFull: ""
              }, null, 8, ["disabled", "color", "title"]),
              _createVNode(_component_LpButton, {
                textColor: "white",
                color: "green-lp-400",
                title: _ctx.$t('dexAssessment.agree'),
                fontWeight: "semibold",
                onClick: _ctx.approveDex,
                class: "my-4 mx-2",
                isWidthFull: ""
              }, null, 8, ["title", "onClick"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isConsole && !_ctx.isShowTimeOverDispute && _ctx.isShowDispute)
          ? (_openBlock(), _createBlock("div", _hoisted_89, [
              _createVNode(_component_LpButton, {
                disabled: 
          _ctx.data.daRemarksPartner.length < 3 ||
            _ctx.data.daProofPhotoDisputePartner.length === 0
        ,
                textColor: "white",
                color: 
          _ctx.data.daRemarksPartner.length < 3 ||
          _ctx.data.daProofPhotoDisputePartner.length === 0
            ? 'gray-lp-600'
            : 'red-lp-100'
        ,
                title: _ctx.$t('dexAssessment.dispute'),
                fontWeight: "semibold",
                onClick: _cache[17] || (_cache[17] = 
          () =>
            _ctx.data.daRemarksPartner.length < 3 ||
            _ctx.data.daProofPhotoDisputePartner.length === 0
              ? {}
              : _ctx.rejectedDex()
        ),
                class: "my-4 mx-2",
                isWidthFull: ""
              }, null, 8, ["disabled", "color", "title"]),
              _createVNode(_component_LpButton, {
                textColor: "white",
                color: "green-lp-400",
                title: _ctx.$t('dexAssessment.accept'),
                fontWeight: "semibold",
                onClick: _ctx.approveDex,
                class: "my-4 mx-2",
                isWidthFull: ""
              }, null, 8, ["title", "onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.showPreviewImage && _ctx.images)
      ? (_openBlock(), _createBlock(_component_PreviewImage, {
          key: 0,
          onClose: () => _ctx.actionModalPreview(false, ''),
          data: _ctx.images
        }, null, 8, ["onClose", "data"]))
      : _createCommentVNode("", true)
  ], 64))
}